import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// ===== COMPONENTE DE RUTA PROTEGIDA =====
export default function Rutasegura({ children }) {
  const [validando, setValidando] = useState(true);
  const [esValido, setEsValido] = useState(false);

  // ===== EFECTOS =====
  useEffect(() => {
    const verificarToken = async () => {
      const token = localStorage.getItem("token");
      
      if (!token) {
        setEsValido(false);
        setValidando(false);
        return;
      }

      try {
        const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/verificar", {
          method: "GET",
          headers: { 
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          setEsValido(true);
        } else {
          localStorage.removeItem("token");
          setEsValido(false);
        }
      } catch (error) {
        console.error("Error al verificar token:", error);
        localStorage.removeItem("token");
        setEsValido(false);
      } finally {
        setValidando(false);
      }
    };

    verificarToken();
  }, []);

  // ===== RENDERIZADO =====
  if (validando) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.2rem',
        color: '#0c1f4d'
      }}>
        Validando acceso...
      </div>
    );
  }

  return esValido ? children : <Navigate to="/Login" replace />;
}